module.exports = __webpack_public_path__ + "img/blue-triangle-right.2c7b718.png";